import { render, staticRenderFns } from "./ConfigIcon.vue?vue&type=template&id=c18fc640&scoped=true&"
import script from "./ConfigIcon.vue?vue&type=script&lang=js&"
export * from "./ConfigIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c18fc640",
  null
  
)

export default component.exports